const ROUTES = {
  "/": {
    "name": "HomePage69f816e4C103490981e22afc3bf84b93",
    "type": "HTML",
    "key": "home-page"
  },
  "/about": {
    "name": "AboutUsPageB4f0272b589942fd9c7148ce6a06e820",
    "type": "HTML",
    "key": "about-us-page"
  },
  "/apply/*": {
    "name": "ApplicationPages1134f108346c4fa4865e8e719b820dba",
    "type": "REFERENCE",
    "key": "application-pages"
  },
  "/events/public": {
    "name": "PublicEventsPage22e87ea4D6fa4247A1e8Cc5ff30f395a",
    "type": "HTML",
    "key": "public-events-page"
  },
  "/join": {
    "name": "JoinUsPage29bfcd8e6078448b9607Cec19b1c4844",
    "type": "REFERENCE",
    "key": "join-us-page"
  }
};

export default ROUTES;